import { render, staticRenderFns } from "./ReportIssueForm.vue?vue&type=template&id=846f7ffc&scoped=true&"
import script from "./ReportIssueForm.vue?vue&type=script&lang=js&"
export * from "./ReportIssueForm.vue?vue&type=script&lang=js&"
import style0 from "./ReportIssueForm.vue?vue&type=style&index=0&id=846f7ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846f7ffc",
  null
  
)

export default component.exports